var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShuaxin = function SvgShuaxin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    className: "shuaxin_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M853.333 768.064A426.112 426.112 0 0 1 512 938.667C276.352 938.667 85.333 747.648 85.333 512S276.352 85.333 512 85.333 938.667 276.352 938.667 512A21.333 21.333 0 0 1 896 512c0-212.075-171.925-384-384-384S128 299.925 128 512s171.925 384 384 384a383.573 383.573 0 0 0 319.36-170.667h-84.757A21.248 21.248 0 0 1 725.333 704c0-11.776 9.664-21.333 21.27-21.333H874.73c5.866 0 11.178 2.346 15.018 6.186l.022.107c3.84 3.883 6.229 9.173 6.229 14.976v128.128c0 11.733-9.472 21.27-21.333 21.27-11.776 0-21.334-9.665-21.334-21.27v-64z"
  })));
};
export default SvgShuaxin;